import {Injectable} from '@angular/core';
import {Brand, Product} from '../../shared/models/models';
import {
  BrandDetails,
  ConfigApiControllerService,
  ProductControllerService,
  ProductDetails
} from "falcon-api";
import {NGXLogger} from "ngx-logger";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private products: Array<Product> = [];

  /**
   * Constrctor
   * @param configApiService Config service instance.
   * @param logger Logger instance.
   */
  constructor(private configApiService: ConfigApiControllerService,
              private falconProductService: ProductControllerService,
              private logger: NGXLogger) {
  }

  getProduct(uuid: string): Observable<ProductDetails> {
    return this.configApiService.getProduct(uuid);
  }

  /**
   * Load products into this service.
   * @param products List of products to load
   */
  loadProducts(products: Array<Product>) {
    this.products = products;
  }

  /**
   * Get List of products
   */
  async getProducts(): Promise<Array<Product>> {
    return new Promise((resolve, reject) => {
      resolve(this.products);
    });
  }

  /**
   * Update product on service.
   * @param product Product to update.
   */
  updateProduct(product: Product): Promise<Array<Product>> {
    return new Promise<Array<Product>>((resolve) => {
      const productDetail = product.mapToDto();
      this.configApiService.updateProduct2(productDetail).subscribe(next => {
        resolve(this.products);
      });
    });
  }

  /**
   * Add product to service.
   * @param brand Brand to add too.
   * @param product Product to add.
   */
  addProduct(product: Product): Promise<Array<Product>> {
    return new Promise<Array<Product>>((resolve) => {
      const productDetail = product.mapToDto();

      this.configApiService.saveProduct1(productDetail, productDetail.brand!.id!).subscribe(next => {
          product.productId = next.id as number;
          this.products.push(product);
          resolve(this.products);
        },
        error => {
          this.logger.debug(error);
        });
    });
  }

  /**
   * Delete product from service.
   * @param product Product to delete.
   */
  deleteProduct(product: Product):
    Promise<Array<Product>> {
    return new Promise<Array<Product>>((resolve) => {
      this.configApiService.deleteProduct1(product.productUID).subscribe(next => {
          const index = this.products.indexOf(product);
          if (index > -1) {
            this.products.splice(index, 1);
          }
          resolve(this.products);
        },
        error => {
          this.logger.debug(error);
        });
    });
  }
}
